module.exports = __webpack_public_path__ + "static/hero-about-2dd5fdd74868030245e12a47bcb44d61.png";